/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { IdentifyParcelsDto } from '../../models/identify-parcels-dto';

export interface GetParcelsPfiList$Params {
  vPfi: string;
}

export function getParcelsPfiList(
  http: HttpClient,
  rootUrl: string,
  params: GetParcelsPfiList$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<IdentifyParcelsDto>> {
  const rb = new RequestBuilder(rootUrl, getParcelsPfiList.PATH, 'get');
  if (params) {
    rb.query('vPfi', params.vPfi, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<IdentifyParcelsDto>;
      }),
    );
}

getParcelsPfiList.PATH = '/identify/parcels';
